"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import pusherInit from "@lib/init/pusher";

export function usePusher() {
  const { status } = useSession();

  const isWindowDefined = typeof window !== "undefined";

  useEffect(() => {
    // Only initialize Pusher when session is loaded and we're on the client
    if (status !== "loading" && isWindowDefined) {
      pusherInit();
    }
  }, [status, isWindowDefined]);
}
